import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IApp, IUser } from "types";

const initialState = {
	user: {},
	user_courses: [],
};

export const AppState = createSlice({
	name: "app",
	initialState,
	reducers: {
		setUser(
			state: IApp,
			action: PayloadAction<IUser>
		) {
			const { email, name, label, id } = action.payload;
			state.user = { email, name, label, id };
		},
		setUserCourses(state: IApp, action: PayloadAction<{ courses: any[] }>) {
			state.user_courses = action.payload.courses;
		},
	},
});

export const { setUser } = AppState.actions;

export default AppState.reducer;
